(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BackupListController', BackupListController);

    BackupListController.$inject = ['$scope', '$filter', '$uibModalInstance', 'SystemConfigService', 'LoginService', 'backupFolderPath'];

    function BackupListController($scope, $filter, $uibModalInstance, SystemConfigService, LoginService, backupFolderPath) {

        var vm = this;

        vm.backupList = {};
        vm.selectedFile = null;

        SystemConfigService.getBackupList(backupFolderPath).then(successList).catch(errorList);

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        function successList(data) {
            vm.backupList.path = data.systemBackupPath;
            vm.backupList.files = data.files.map(function (file, index) {
                return {index: index + 1, name: file};
            });
        }

        function errorList(response) {
            SystemConfigService.errorModalConstructor(response, 'getBackupList');
            if (response.status == 409) {
                vm.close();
            }
        }

        vm.restore = function () {

            var dataAction = {
                action: 'restore',
                confirmation: true,
                service: 'UserService',
                methodService: 'getLoggedUsers',
                methodExtra: function (users) {
                    var params = {
                        filename: vm.selectedFile.name,
                        path: vm.backupList.path
                    };
                    var dataActionConfirm = {
                        action: 'confirmRestore',
                        methodService: 'restoreBackup',
                        methodParam: params,
                        methodExtra: function (data, modalInstance) {
                            if (modalInstance) {
                                modalInstance.closed.then(LoginService.logout);
                            }
                        }
                    };

                    var usersList = users.map(function (user) {
                        return user.username;
                    }).join(', ');

                    SystemConfigService.confirmationModalConstructor(dataActionConfirm, usersList);
                }
            };

            var path = vm.backupList.path;
            var slash = path.indexOf('\\') > -1 ? '\\' : '/';
            var backupPath = path;
            if (path.charAt(path.length - 1) != slash) {
                backupPath += slash;
            }
            backupPath += vm.selectedFile.name;

            SystemConfigService.confirmationModalConstructor(dataAction, backupPath);
        }
    }
})();
